import { useEffect, useState } from 'react';
import Combobox from "react-widgets/Combobox";
import styled from '@emotion/styled';
import { useTheme } from "@mui/material";


export const ComboboxWrapperStyled = styled.div`
 .rw-state-focus .rw-widget-picker {
    border-color: ${({ main }) => main};
    box-shadow: 0px 0px 0px 3px rgba(${({ mainRGB }) => mainRGB}, 0.25);
  }
`;

const ComboboxField = (props) => {
  const { id, name, type, typeName, order, values, input: { onChange, onBlur, value: stateValue }, required } = props;

  const { palette } = useTheme();
  const { primary: { contrastText, main, mainRGB } } = palette;

  const [options] = useState(values);
  const [value, setValue] = useState();

  const selectHandler = (changeValue) => {
    setValue(changeValue);
    // console.log('selectHandler', changeValue);

    if (!changeValue && !required) {
      onChange(null);
    }
  };

  const changeHandler = (val) => {
    // console.log('changeHandler', val);
    // return onChange(val);

    return onChange({
      id,
      typeName, //type,
      order,
      result: val
    });
  };

  const blurHandler = () => {
    // console.log('blurHandler', stateValue);

    if (stateValue?.result) {
      return setValue(stateValue.result?.id);
    }
    return setValue(null);
  }

  useEffect(() => {
    if (options && options.length > 0) {
      for (let option of options) {
        if (option.default) {
          setValue(option.id);
          // onChange(option);
          onChange({
            id,
            typeName, //type,
            order,
            result: option
          });

          break;
        }
      }
    }
  }, []);

  return (
    <ComboboxWrapperStyled main={main} mainRGB={mainRGB}>
      <Combobox
        value={value}
        dataKey="id"
        textField="label"
        // defaultValue={value}
        data={values}
        onChange={(value) => { selectHandler(value) }}
        onSelect={(value) => { changeHandler(value) }}
        onBlur={blurHandler}
      />
    </ComboboxWrapperStyled>
  );
}

export default ComboboxField;